var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21094 0.875L17.9766 25.625L26.6953 0.875H35.9297V35H28.875V25.6719L29.5781 9.57031L20.3672 35H15.5391L6.35156 9.59375L7.05469 25.6719V35H0.0234375V0.875H9.21094Z",
    fill: "url(#paint0_linear_6_78)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_78",
    x1: 17.9766,
    y1: 0.875,
    x2: 17.9766,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9AE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM);
export default __webpack_public_path__ + "static/media/M.febea0d0a0f90878f71de3e77db4109e.svg";
export { ForwardRef as ReactComponent };